
  import { defineComponent } from "vue"

  export default defineComponent({
    name: "Paginator",
    emits: ["previousPage", "nextPage"],
    setup(_: any, { emit }: any) {
      const previousPage = () => emit("previousPage")
      const nextPage = () => emit("nextPage")

      return { previousPage, nextPage }
    },
  })
